import { Directive, ElementRef, inject, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[redBooleanToYes]',
  standalone: false
})
export class BooleanToYesDirective implements OnChanges {
  @Input('redBooleanToYes') enabled: boolean | undefined = false;

  element: ElementRef;

  constructor() {
    this.element = inject(ElementRef);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['enabled']) {
      switch (changes['enabled'].currentValue) {
        case true:
          this.element.nativeElement.innerText = 'Yes';
          this.element.nativeElement['color'] = 'success';
          break;
        case false:
          this.element.nativeElement.innerText = 'No';
          this.element.nativeElement['color'] = 'danger';
          break;
      }
    }
  }
}
